export class StickyHighlightHTMLElement extends HTMLElement {
    private isTouch = window.matchMedia('(pointer: coarse)');
    private isTablet = window.matchMedia('(min-width: 768px)');
    private language = document.documentElement.lang;
    private toggle: HTMLButtonElement;
    private buttonName: string;
    // private contentTitle: string;
    private destinationUrl: string;
    // private alreadyOpened: boolean;

    private toggleAbstractContent = (): void => {
        if (this.toggle.getAttribute('aria-expanded') === 'true') {
            this.toggle.setAttribute('aria-expanded', 'false');
        } else {
            this.toggle.setAttribute('aria-expanded', 'true');
        }
    }

    private goToHighlight = (e: PointerEvent): void => {
        const target = <HTMLElement>e.target
        if (target.closest('#sticky-highlight-abstract-toggle')) {
            return
        }
        this.removeEventListener('click', this.goToHighlight);
        (<HTMLAnchorElement>this.querySelector('a')).click();
    }

    private reset(): void {
        // SMARTPHONES
        this.removeEventListener('click', this.goToHighlight);
        // OTHER TOUCH DEVICES
        this.toggle.removeEventListener('click', this.toggleAbstractContent);
        // DESKTOPS
        this.removeEventListener('mouseenter', this.toggleAbstractContent);
        this.removeEventListener('mouseleave', this.toggleAbstractContent);
    }

    private setMediaTypeBehavior = (): void => {
        this.reset();

        const abstractContainer = this.querySelector('#sticky-highlight-abstract-container') as HTMLElement

        if (!this.isTablet.matches) {
            // SMARTPHONES: no abstract behavior
            this.toggle.setAttribute('aria-expanded', 'true');
            this.addEventListener('click', this.goToHighlight);

        } else if (this.isTouch.matches) {
            // OTHER TOUCH DEVICES: show abstract at click on toggle
            abstractContainer.style.transition = 'none';
            this.toggle.setAttribute('aria-expanded', 'false');
            setTimeout(() => {
                abstractContainer.style.transition = '';
            }, 300);
            this.toggle.addEventListener('click', this.toggleAbstractContent);

        } else {
            // DESKTOPS: show abstract at hover
            abstractContainer.style.transition = 'none';
            this.toggle.setAttribute('aria-expanded', 'false');
            setTimeout(() => {
                abstractContainer.style.transition = '';
            }, 300);
            this.addEventListener('mouseenter', this.toggleAbstractContent)
            this.addEventListener('mouseleave', this.toggleAbstractContent)
        }
    }

    public connectedCallback(): void {
        document.body.classList.add('sticky-highlight-visible');

        this.toggle = this.querySelector('#sticky-highlight-abstract-toggle');
        this.buttonName = this.querySelector('#sticky-highlight-abstract-container a span').textContent;
        // this.contentTitle = this.querySelector('#sticky-highlight-abstract-container a').getAttribute('title');
        const url = this.querySelector('#sticky-highlight-abstract-container a').getAttribute('href');
        
        try {
            this.destinationUrl = new URL(url, window.location.origin).href;
        } catch (error) {
            console.error(error);
            this.destinationUrl = url;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'sticky_interaction',
            eventCategory: 'not_present',
            eventAction: 'viewed',
            eventLabel: `language_${this.language}`,
            file_name: document.title,
            page_location: window.location.href,
            destination_url: 'not_present'
        });

        this.addEventListener('click', this.trackingAnalytics, true);

        this.toggle.addEventListener('click', () => {
            if (this.toggle.getAttribute('aria-expanded') === 'true') {
                document.body.classList.remove('sticky-highlight-visible');
                setTimeout(() => this.classList.add('hidden'), 300);
                this.reset();
                this.isTablet.removeEventListener('change', this.setMediaTypeBehavior);
                this.isTouch.removeEventListener('change', this.setMediaTypeBehavior);
            }
        });

        this.setMediaTypeBehavior();
        this.isTablet.addEventListener('change', this.setMediaTypeBehavior);
        this.isTouch.addEventListener('change', this.setMediaTypeBehavior);
    }

    public disconnectedCallback(): void {
        this.reset();
        this.isTablet.removeEventListener('change', this.setMediaTypeBehavior);
        this.isTouch.removeEventListener('change', this.setMediaTypeBehavior);
    }

    private trackingAnalytics = (event: PointerEvent) => {
        this.buttonName = this.querySelector('#sticky-highlight-abstract-container a span').textContent;
        // this.contentTitle = this.querySelector('#sticky-highlight-abstract-container a').getAttribute('title');
        const url = this.querySelector('#sticky-highlight-abstract-container a').getAttribute('href');
        
        try {
            this.destinationUrl = new URL(url, window.location.origin).href;
        } catch (error) {
            console.error(error);
            this.destinationUrl = url;
        }
        const target = <HTMLElement>event.target;

        if (target.closest('#sticky-highlight-abstract-container a')) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'sticky_interaction',
                    eventCategory: `cta - ${this.buttonName}`,
                    eventAction: 'clicked',
                    eventLabel: `language_${this.language}`,
                    file_name: document.title,
                    page_location: window.location.href,
                    destination_url: this.destinationUrl
                });
        } else if (target.closest('#sticky-highlight-abstract-toggle') && this.toggle.ariaExpanded === 'true') {
            window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'sticky_interaction',
                    eventCategory: 'not_present',
                    eventAction: 'closed',
                    eventLabel: `language_${this.language}`,
                    file_name: document.title,
                    page_location: window.location.href,
                    destination_url: 'not_present'
                });
        }
    }
}